import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";

export interface CustomerResponse {
    cus_id?: number | null;
    cus_accno?: string | null;
    cus_code?: string | null;
    cus_name?: string | null;
    cus_title?: string | null;
    cus_crdate?: string | null;
    cus_crby?: string | null;
    cus_mddate?: string | null;
    cus_mdby?: string | null;
    cus_groupid?: number | null;
    cus_active?: boolean | number | null;
    cus_add1?: string | null;
    cus_add2?: string | null;
    cus_add3?: string | null;
    cus_add4?: string | null;
    cus_tinno?: string | null;
    cus_tep1?: string | null;
    cus_tep2?: string | null;
    cus_email?: string | null;
    cus_dob?: string | null;
    cus_prof?: string | null;
    cus_spouse?: string | null;
    cus_creditlimit?: number | null;
    cus_creditperiod?: number | null;
    cus_opbal?: number | null;
    cus_purchase?: number | null;
    cus_returns?: number | null;
    cus_creditnote?: number | null;
    cus_debitnote?: number | null;
    cus_payment?: number | null;
    cus_balance?: number | null;
    cus_loyaltyactive?: boolean | number | null;
    cus_openpoint?: number | null;
    cus_earnepoint?: number | null;
    cus_redeempoint?: number | null;
    cus_points?: number | null;
}

export type CustomerCreateUpdateRequest = Omit<CustomerResponse, "cus_id" | "cus_crdate" | "cus_crby" | "cus_mddate" | "cus_mdby">;

export const getAllCustomers = async (): Promise<CustomerResponse[]> => {
    try {
        const response: ApiResponse<CustomerResponse[] | null> = (
            await apiClient.get("/pos_customer/all", {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        return response.data || [];
    } catch (error: any) {
        if (error?.response?.status === 401) {
            throw new Error("Not authorized to load customers. Please sign in with backend authentication.");
        }

        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error("Failed to fetch customers");
    }
};

export const createCustomer = async (customerData: CustomerCreateUpdateRequest): Promise<{ cus_id: number }> => {
    try {
        const response: ApiResponse<{ cus_id: number }> = (
            await apiClient.post("/pos_customer/create", customerData, {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        return response.data;
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error("Failed to create customer");
    }
};

export const updateCustomer = async (cusId: number, customerData: CustomerCreateUpdateRequest): Promise<{ cus_id: number }> => {
    try {
        const response: ApiResponse<{ cus_id: number }> = (
            await apiClient.put(`/pos_customer/update/${cusId}`, customerData, {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        return response.data;
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error("Failed to update customer");
    }
};
